"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Exception_1 = require("../../Exceptions/Exception");
var CssParseException = /** @class */ (function (_super) {
    __extends(CssParseException, _super);
    /**
     *
     */
    function CssParseException(name, nLine, sLine, message) {
        return _super.call(this, message) || this;
    }
    return CssParseException;
}(Exception_1.Exception));
exports.default = CssParseException;

//# sourceMappingURL=CssParseException.js.map
